<template>
  <div>
    <!-- {{masterBiodata}} -->
    <b-card no-body class="text-center mt-1">
      <template #header>
        <b-container fluid class="w-100">
          <b-row>
            <b-col cols="8" class="text-left">
              <h4 class="mb-0">
                Nomor Induk Advokat (NIA)
              </h4>
            </b-col>
            <b-col cols="4" class="text-right">
              <!-- <b-badge pill variant="success">Terverifikasi</b-badge> -->
            </b-col>
          </b-row>
        </b-container>
      </template>
      <b-card-body class="text-left">
        <b-row>
          <b-col sm="12">
            <!-- toast -->
            <!-- {{ this.generalData }} -->
            <b-form-group label="NIA" label-for="nia" class="mb-2">
              <b-form-input v-model="localBiodata.nia" placeholder="NIA" />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Tanggal NIA Diberikan"
              label-for="tanggal-nia"
              class="mb-2"
            >
              <flat-pickr
                v-model="localBiodata.tanggal_nia"
                class="form-control"
                placeholder="Tanggal NIA diberikan"
              />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group
              label="Tanggal Berakhir Keanggotaan"
              label-for="tanggal-berakhir"
            >
              <flat-pickr
                v-model="localBiodata.tanggal_berakhir"
                class="form-control"
                placeholder="Tanggal Keanggotaan Berakhir"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <template #footer>
        <b-container fluid class="w-100">
          <b-row>
            <b-col cols="8" class="text-left">
              <b-button
                v-if="showSimpan()"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="simpan"
              >
                Simpan
              </b-button>
            </b-col>
            <!-- <b-col cols="4" class="text-right">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                @click="confirmDelete"
              >
                Hapus
              </b-button>
            </b-col> -->
          </b-row>
        </b-container>
      </template>
      <b-overlay :show="showOverlay" no-wrap>
        <template #overlay>
          <div v-if="isProcessing" class="text-center">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
          <div
            v-else
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="false"
            aria-labelledby="form-confirm-label"
            class="text-center p-3"
          >
            <p><strong id="form-confirm-label">Are you sure?</strong></p>
            <div class="d-flex">
              <b-button
                variant="outline-danger"
                class="mr-3"
                @click="onOverlayCancel"
              >
                Cancel
              </b-button>
              <b-button variant="outline-success" @click="onOverlayOk">
                OK
              </b-button>
            </div>
          </div>
        </template>
      </b-overlay>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BCardBody,
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
  BSpinner,
  BContainer,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { api } from '@/hap-sia/setup'

export default {
  components: {
    BCard,
    // BCardHeader,
    BCardBody,
    // BCardText,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    flatPickr,
    BOverlay,
    BSpinner,
    BContainer,
    // BBadge,
  },
  directives: {
    Ripple,
  },
  props: ['masterBiodata'],
  data() {
    return {
      localBiodata: this.masterBiodata,
      showOverlay: false,
      isProcessing: false,
    }
  },
  mounted() {},
  methods: {
    confirmDelete() {
      this.showOverlay = true
    },
    async simpan() {
      this.showOverlay = true
      this.isProcessing = true
      // await new Promise(r => setTimeout(r, 2000))
      try {
        if (this.localBiodata.nia === '') {
          this.localBiodata.nia = null
        }
        if (this.localBiodata.tanggal_nia === '') {
          this.localBiodata.tanggal_nia = null
        }
        if (this.localBiodata.tanggal_berakhir === '') {
          this.localBiodata.tanggal_berakhir = null
        }
        await api().patch('keanggotaan/nia', {
          id: this.localBiodata.id,
          nia: this.localBiodata.nia,
          tanggal_nia: this.localBiodata.tanggal_nia,
          tanggal_berakhir: this.localBiodata.tanggal_berakhir,
        })
      } catch (error) {
        this.makeToast('danger', 'Gagal', error.response.data.message, true)
        this.showOverlay = false
        this.isProcessing = false
        return
      }
      this.showOverlay = false
      this.isProcessing = false
      this.makeToast('success', 'Sukses', 'Data berhasil disimpan')
    },
    async delete() {
      this.showOverlay = true
      this.isProcessing = true
      // await new Promise(r => setTimeout(r, 2000))
      this.showOverlay = false
      this.isProcessing = false
      this.makeToast('success', 'Sukses', 'Data berhasil dihapus')
    },
    onOverlayCancel() {
      this.showOverlay = false
    },
    onOverlayOk() {
      this.isProcessing = true
      this.delete()
    },
    showSimpan() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (
        userData.default_role === 'user' ||
        userData.default_role === 'member'
      ) {
        return false
      }

      return true
    },
    makeToast(variant = null, title, body, noAutoHide = false) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        autoHideDelay: 3000,
        noAutoHide,
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
